<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Woocommerce",
    "pageDesc":"We help you build a store on wordpress using woocommerce platform for easy integrations and full store functionalities.",
    "mantra":"Build your store with |WordPress and |Woocommerce.",
    "sec1Items":{
      "1":{
        "title":"App development",
        "desc":"Stay on top of your store activities and have instance updates with an App that monitors your store operations."
      },
      "2":{
        "title":"Website custom development",
        "desc":"Starting from your business needs, customize a solution that sirebalieb and optimized for search engines."
      },
      "3":{
        "title":"Themes and custom design",
        "desc":"Designing your users journey in the store based on the UX best practices to provide you with a store that is both functional and beautiful. "
      },
      "4":{
        "title":"Customized plugin development",
        "desc":"Building features around your business needs through plugins that can be easily integrated into your store infrastructure from shopping cart to reporting functionalities."
      },
      "5":{
        "title":"Maintenance and support",
        "desc":"We walk you through the development issues and suggest solutions for better performance and stability."
      },
      "6":{
        "title":"Migration, configuration and installation",
        "desc":"Migrate your Shopify or Magento store to Woocommerce without losing data or impacting your store search ranking."
      }
    },
    "sec2":"Grow your business with functional store.",
    "sec2Items":{
      "1":{
        "title":"Full store control",
        "desc":"Customize your store look and have a store that scales with your business. Whether you are selling your products or being an affiliate for other brands."
      },
      "2":{
        "title":"Scalable platform",
        "desc":"Whether you earn more clients, receive more orders or have more products, we give you a platform that scales with your needs so you don’t have to change it later on."
      },
      "3":{
        "title":"Various payment methods",
        "desc":"Integrate the different payment methods into you store system from cash on delivery, to check, credit cards and more."
      },
      "4":{
        "title":"Extendable features",
        "desc":"From custom offerings to free shipping and flat rates, integrate any plugin you need and customize your store to each country rules."
      },
      "5":{
        "title":"Inventory tracking",
        "desc":"Have insights on your inventory and get notified on when to restock and fulfill orders all the way."
      },
      "6":{
        "title":"Reporting system",
        "desc":"Have an insight into your store operations and optimize for better performance and higher revenues."
      }
    },
    "cta":"Build your woocommerce <br> store now."
  },
  "ar": {
    "pageTitle":"ووكومرس",
    "pageDesc":"نساعدك على بناء متجرك باستخدام منصة ووكومرس من أجل توفير سهولة التكامل ووظائف المتجر المتكاملة التي تساعدك على نمو اعمالك.",
    "mantra":"أسس متجرك من خلال |ووردبريس ووكومرس.",
    "sec1Items":{
      "1":{
        "title":"برمجة التطبيقات",
        "desc":"تابع أنشطة متجرك على الدوام واحصل على التحديثات أولًا بأول من خلال تطبيق يراقب عمليات متجرك المختلفة."
      },
      "2":{
        "title":"برمجة مخصصة للموقع",
        "desc":"نفهم احتياجات ومتطلبات عملك ثم نقوم بتخصيص حل مناسب معها وكذلك نهيئه من أجل محركات البحث."
      },
      "3":{
        "title":"القوالب والتصميمات المخصصة",
        "desc":"نوفر للمستخدمين رحلة شرائية ممتعة عبر متجرك من خلال الاهتمام بقواعد تجربة المستخدم من أجل تزويد متجرك بالوظائف والجمال في آن واحد."
      },
      "4":{
        "title":"برمجة الاضافات المخصصة ",
        "desc":"نبني المميزات التي تلبي جميع احتياجات عملك من خلال المكونات الإضافية  التي يمكن دمجها بسهولة مع البنية التحتية لمتجرك بداية من عربة التسوق إلى التقارير."
      },
      "5":{
        "title":"الصيانة والدعم",
        "desc":"نكتشف المشكلات ونعمل على حلها أولًا بأول من خلال حلول تعمل على تحسين الأداء وتجل متجرك أكثر استقرارًا."
      },
      "6":{
        "title":"النقل والتركيب والتكوين",
        "desc":"يمكنك نقل متجرك من ماجنتو أو شوبيفاي إلى ووكومرس بدون أي خوف من فقد البيانات أو التأثير على ترتيب المتجر في محرك البحث."
      }
    },
    "sec2":"طور أعمالك من خلال متجر سهل الاستخدام",
    "sec2Items":{
      "1":{
        "title":"السيطرة الكاملة على المتجر",
        "desc":"خصص مظهر متجرك واحصل على ما يناسب طبيعة عملك، سواء كنت تبيع منتجاتك الخاصة أو تسوق بالعمولة لمنتجات شركة آخرى."
      },
      "2":{
        "title":"منصة قابلة للتطوير",
        "desc":"سواء كنت تكتسب المزيد من العملاء أو تتلقي المزيد من الطلبات أو لديك الكثير من المنتجات، نقدم لك منصة تتناسب مع احتياجاتك حتى لا تضطر إلى تغييرها لاحقًا."
      },
      "3":{
        "title":"طرق الدفع المختلفة",
        "desc":"يمكنك دمج طرق الدفع المختلفة في متجرك من الدفع نقدًا عند التسليم حتى بطاقات الإئتمان ...وأكثر من ذلك."
      },
      "4":{
        "title":"مميزات قابلة للتوسع",
        "desc":"من العروض المخصصة إلى الشحن المجاني والأسعار الثابتة، يمكنك دمج أي مكون إضافي تحتاج إليه وخصص متجرك وفقًا لقواعد أي بلد."
      },
      "5":{
        "title":"تتبع المخزون",
        "desc":"احصل على الرؤى حول مخزن متجرك واحصل على إشعار بشأن موعد إعادة تخزين الطلبات وتنفيذها طوال الوقت."
      },
      "6":{
        "title":"نظام التقارير",
        "desc":"احصل على تقارير شاملة حول عملياتك من أجل تحسين أدائك وايرادتك وجذب المزيد من العملاء."
      }
    },
    "cta":"قم ببناء متجر <br> ووكومرس الآن"
  }
}
</i18n>
